<template>
<div class="chapter">
<div class="inner_page">
<div id="toc">
<h1 id="toc-title">Emersyn</h1>
<ol class="toc">
<li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgement">Acknowledgement</a></li>
<li id="toc-li-5"><a href="#/text/ch005#introduction">Introduction</a></li>
<li id="toc-li-6"><a href="#/text/ch006#part-one">Part One</a>
<ol>
<li id="toc-li-7"><a href="#/text/ch007#chapter-one-the-whileys">Chapter One: The Whileys</a>
<ol class="toc">
<li id="toc-li-8"><a href="#/text/ch007#mason"></a></li>
</ol>
</li>
<li id="toc-li-9"><a href="#/text/ch008#chapter-two-the-origin-of-emersyn">Chapter Two: The Origin of
              Emersyn</a>
<ol class="toc">
<li id="toc-li-10"><a href="#/text/ch008#emersyn"></a></li>
</ol>
</li>
<li id="toc-li-11"><a href="#/text/ch009#chapter-three-sins-of-the-fathers">Chapter Three: Sins of the
              Fathers</a>
<ol class="toc">
<li id="toc-li-12"><a href="#/text/ch009#acrams-kids"> </a></li>
<li id="toc-li-13"><a href="#/text/ch009#faith"></a></li>
<li id="toc-li-14"><a href="#/text/ch009#the-boys"> </a></li>
</ol>
</li>
<li id="toc-li-15"><a href="#/text/ch010#chapter-four-the-generations">Chapter Four: The Generations</a>
<ol class="toc">
<li id="toc-li-16"><a href="#/text/ch010#the-boys-1"> </a></li>
</ol>
</li>
<li id="toc-li-17"><span href="#/text/ch011#chapter-five-the-ripple-effect" title="Link target outside of Sample">Chapter Five: The Ripple Effect</span>
</li>
<li id="toc-li-18"><span href="#/text/ch012#chapter-six-a-twist-of-fate" title="Link target outside of Sample">Chapter Six: A Twist of Fate</span>
<ol class="toc">
<li id="toc-li-19"><span href="#/text/ch012#faith-1" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-20"><span href="#/text/ch013#chapter-seven-the-angry-seed" title="Link target outside of Sample">Chapter Seven: The Angry Seed</span>
<ol class="toc">
<li id="toc-li-21"><span href="#/text/ch013#laika" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-22"><span href="#/text/ch014#chapter-eight-to-this-manner-born" title="Link target outside of Sample">Chapter Eight: To This Manner
              Born</span>
<ol class="toc">
<li id="toc-li-23"><span href="#/text/ch014#mason-1" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-24"><span href="#/text/ch015#chapter-nine-a-new-life" title="Link target outside of Sample">Chapter Nine: A New Life</span>
<ol class="toc">
<li id="toc-li-25"><span href="#/text/ch015#laika-1" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-26"><span href="#/text/ch016#chapter-ten-no-stealing-from-the-past" title="Link target outside of Sample">Chapter Ten: No Stealing from
              the Past</span>
<ol class="toc">
<li id="toc-li-27"><span href="#/text/ch016#amoury-cardinal" title="Link target outside of Sample"> </span></li>
</ol>
</li>
<li id="toc-li-28"><span href="#/text/ch017#chapter-eleven-appearance-vs-reality" title="Link target outside of Sample">Chapter Eleven: Appearance vs
              Reality</span>
<ol class="toc">
<li id="toc-li-29"><span href="#/text/ch017#mason-2" title="Link target outside of Sample"></span></li>
<li id="toc-li-30"><span href="#/text/ch017#amoury" title="Link target outside of Sample"></span></li>
<li id="toc-li-31"><span href="#/text/ch017#mason-3" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-32"><span href="#/text/ch018#chapter-twelve-a-unique-gift" title="Link target outside of Sample">Chapter Twelve: A Unique Gift</span>
<ol class="toc">
<li id="toc-li-33"><span href="#/text/ch018#valencia" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-34"><span href="#/text/ch019#chapter-thirteen-a-knife-not-a-wife" title="Link target outside of Sample">Chapter Thirteen: A Knife Not a
              Wife</span>
<ol class="toc">
<li id="toc-li-35"><span href="#/text/ch019#emery" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-36"><span href="#/text/ch020#chapter-fourteen-an-attack-of-conscience" title="Link target outside of Sample">Chapter Fourteen: An Attack
              of Conscience</span>
<ol class="toc">
<li id="toc-li-37"><span href="#/text/ch020#amoury-1" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-38"><span href="#/text/ch021#chapter-fifteen-chronicles-of-the-third-child" title="Link target outside of Sample">Chapter Fifteen:
              Chronicles of the Third Child</span>
<ol class="toc">
<li id="toc-li-39"><span href="#/text/ch021#gabriel" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-40"><span href="#/text/ch022#chapter-sixteen-the-bad-seed" title="Link target outside of Sample">Chapter Sixteen: The Bad Seed</span>
<ol class="toc">
<li id="toc-li-41"><span href="#/text/ch022#valen-finley" title="Link target outside of Sample"> </span></li>
</ol>
</li>
<li id="toc-li-42"><span href="#/text/ch023#chapter-seventeen-when-it-rains-it-pours" title="Link target outside of Sample">Chapter Seventeen: When It
              Rains, It Pours</span>
<ol class="toc">
<li id="toc-li-43"><span href="#/text/ch023#amoury-2" title="Link target outside of Sample"></span></li>
<li id="toc-li-44"><span href="#/text/ch023#val" title="Link target outside of Sample"></span></li>
<li id="toc-li-45"><span href="#/text/ch023#mason-4" title="Link target outside of Sample"></span></li>
<li id="toc-li-46"><span href="#/text/ch023#amoury-3" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-47"><span href="#/text/ch024#chapter-eighteen-disruptions-and-disturbances" title="Link target outside of Sample">Chapter Eighteen:
              Disruptions and Disturbances</span>
<ol class="toc">
<li id="toc-li-48"><span href="#/text/ch024#mason-5" title="Link target outside of Sample"></span></li>
</ol>
</li>
</ol>
</li>
<li id="toc-li-49"><span href="#/text/ch025#part-two" title="Link target outside of Sample">Part Two</span>
<ol>
<li id="toc-li-50"><span href="#/text/ch026#chapter-nineteen-the-twins" title="Link target outside of Sample">Chapter Nineteen: The Twins</span>
<ol class="toc">
<li id="toc-li-51"><span href="#/text/ch026#melisandre" title="Link target outside of Sample"></span></li>
<li id="toc-li-52"><span href="#/text/ch026#amethyst" title="Link target outside of Sample"></span></li>
<li id="toc-li-53"><span href="#/text/ch026#melisandre-1" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-54"><span href="#/text/ch027#chapter-twenty-loss" title="Link target outside of Sample">Chapter Twenty: Loss</span>
<ol class="toc">
<li id="toc-li-55"><span href="#/text/ch027#everest" title="Link target outside of Sample"></span></li>
<li id="toc-li-56"><span href="#/text/ch027#amoury-4" title="Link target outside of Sample"></span></li>
<li id="toc-li-57"><span href="#/text/ch027#amethyst-1" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-58"><span href="#/text/ch028#chapter-twenty-one-a-quandry" title="Link target outside of Sample">Chapter Twenty-One: A Quandry</span>
<ol class="toc">
<li id="toc-li-59"><span href="#/text/ch028#mason-6" title="Link target outside of Sample"></span></li>
<li id="toc-li-60"><span href="#/text/ch028#amoury-5" title="Link target outside of Sample"></span></li>
<li id="toc-li-61"><span href="#/text/ch028#mason-7" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-62"><span href="#/text/ch029#chapter-twenty-two-the-confession" title="Link target outside of Sample">Chapter Twenty-Two: The
          Confession</span>
<ol class="toc">
<li id="toc-li-63"><span href="#/text/ch029#amoury-6" title="Link target outside of Sample"></span></li>
<li id="toc-li-64"><span href="#/text/ch029#mason-8" title="Link target outside of Sample"></span></li>
<li id="toc-li-65"><span href="#/text/ch029#amethyst-2" title="Link target outside of Sample"></span></li>
<li id="toc-li-66"><span href="#/text/ch029#mason-9" title="Link target outside of Sample"></span></li>
<li id="toc-li-67"><span href="#/text/ch029#amoury-7" title="Link target outside of Sample"></span></li>
<li id="toc-li-68"><span href="#/text/ch029#mason-10" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-69"><span href="#/text/ch030#chapter-twenty-three-the-search" title="Link target outside of Sample">Chapter Twenty-Three: The Search</span>
<ol class="toc">
<li id="toc-li-70"><span href="#/text/ch030#mason-11" title="Link target outside of Sample"></span></li>
<li id="toc-li-71"><span href="#/text/ch030#amoury-8" title="Link target outside of Sample"></span></li>
<li id="toc-li-72"><span href="#/text/ch030#mason-12" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-73"><span href="#/text/ch031#chapter-twenty-four-the-aftermath" title="Link target outside of Sample">Chapter Twenty-Four: The
          Aftermath</span>
<ol class="toc">
<li id="toc-li-74"><span href="#/text/ch031#amoury-9" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-75"><span href="#/text/ch032#chapter-twenty-five-the-discovery" title="Link target outside of Sample">Chapter Twenty-Five: The
          Discovery</span>
<ol class="toc">
<li id="toc-li-76"><span href="#/text/ch032#mason-13" title="Link target outside of Sample"></span></li>
<li id="toc-li-77"><span href="#/text/ch032#amoury-10" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-78"><span href="#/text/ch033#chapter-twenty-six-the-obsequies" title="Link target outside of Sample">Chapter Twenty-Six: The
          Obsequies</span>
<ol class="toc">
<li id="toc-li-79"><span href="#/text/ch033#val-1" title="Link target outside of Sample"></span></li>
<li id="toc-li-80"><span href="#/text/ch033#mason-14" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-81"><span href="#/text/ch034#chapter-twenty-seven-the-coalesce" title="Link target outside of Sample">Chapter Twenty-Seven: The
          Coalesce</span>
<ol class="toc">
<li id="toc-li-82"><span href="#/text/ch034#amoury-11" title="Link target outside of Sample"></span></li>
<li id="toc-li-83"><span href="#/text/ch034#val-2" title="Link target outside of Sample"></span></li>
<li id="toc-li-84"><span href="#/text/ch034#amethyst-3" title="Link target outside of Sample"></span></li>
<li id="toc-li-85"><span href="#/text/ch034#mason-15" title="Link target outside of Sample"></span></li>
</ol>
</li>
<li id="toc-li-86"><span href="#/text/ch035#chapter-twenty-eight-cyrils-nightmare" title="Link target outside of Sample">Chapter Twenty-Eight: Cyril’s
          Nightmare</span></li>
</ol>
</li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?3b6e9578